type IconProps = {
	width?: number;
	height?: number;
	color?: string;
	secondaryColor?: string;
}

export const OnTheRoadIcon = (props:IconProps) => {
	const {
		width = 19,
		height = 19,
		color = 'var(--func-blue-default)'
	} = props;
	return (
		<>
			<svg role={'img'} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={width} height={height} {...props}>
				<path d='M12,2.12C6.55,2.12,2.12,6.55,2.12,12s4.43,9.88,9.88,9.88,9.88-4.43,9.88-9.88S17.45,2.12,12,2.12ZM12,20.12c-1.5,0-2.91-.41-4.12-1.12,1.24-.74,2.65-1.12,4.12-1.12s2.88.38,4.12,1.12c-1.21.71-2.62,1.12-4.12,1.12ZM17.6,17.87c-1.64-1.14-3.6-1.75-5.6-1.75s-3.96.61-5.6,1.75c-1.55-1.47-2.52-3.56-2.52-5.87C3.88,7.52,7.52,3.88,12,3.88s8.12,3.64,8.12,8.12c0,2.31-.97,4.4-2.52,5.87ZM7.88,10c0,.48-.39.88-.88.88s-.88-.39-.88-.88.39-.88.88-.88.88.39.88.88ZM10.88,7c0,.48-.39.88-.88.88s-.88-.39-.88-.88.39-.88.88-.88.88.39.88.88ZM17.88,10c0,.48-.39.88-.88.88s-.88-.39-.88-.88.39-.88.88-.88.88.39.88.88ZM14.81,7.33l-1.38,3.46c.28.33.45.75.45,1.21,0,1.03-.85,1.88-1.88,1.88s-1.88-.85-1.88-1.88c0-.96.74-1.77,1.68-1.86l1.39-3.47c.18-.44.68-.66,1.14-.48.44.18.66.69.48,1.14Z' fill={color} />
			</svg>
		</>
	);
};
